import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BatteryChargeStatus from './BatteryChargeStatus';
import { NO_INFORMATION_AVAILABLE } from '../../../constants';

/**
 * This component represents specifically the Battery Card which slightly differs from the rest of the cards.
 * Currently it shows Battery Life title, it's corresponding icon and a graph.
 *
 * @param {JSX.Element} icon - Icon to show next to the title
 * @param {String} url - URL to which the user is redirected when they click on the card.
 * @param {String} title - Title of the card
 * @param {String} mainMetric - The last percentage retrieved by the device
 * @param {String} requestTimestamp - The exact time when the percentage was retrieved for the last time
 * @param {Boolean} cardError - Indicates if there is any data to show.
 *
 */
const BatteryLifeCard = ({ icon: IconComponent, url, title, mainMetric, cardError = false }) => {
  const [batteryPercentage, setBatteryPercentage] = useState(null);

  useEffect(() => {
    setBatteryPercentage(mainMetric);
  }, [mainMetric]);

  const showNoDataAvailableMessage = cardError || mainMetric === null;

  return (
    <Link
      to={url}
      className={`group relative bg-white text-left rounded-3xl p-8 shadow-sm flex flex-col justify-around gap-3 w-full min-w-[300px] max-w-[350px] min-h-[280px]  transform transition-all duration-200 ease-out
      hover:scale-105 hover:shadow-lg `}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {IconComponent && (
            <div className="text-black w-6 h-6">
              <IconComponent className="w-full h-full" />
            </div>
          )}
          <h2 className="text-black font-bold text-2xl">{title}</h2>
        </div>
      </div>
      <div className="flex justify-center items-center">
        {showNoDataAvailableMessage ? (
          <p className="text-sm font-medium text-gray-500 mt-6">{NO_INFORMATION_AVAILABLE}</p>
        ) : (
          <>
            <div className="flex flex-col items-center w-full max-w-xs sm:max-w-sm md:max-w-md"></div>
            <div>
              <BatteryChargeStatus percentage={batteryPercentage} />
            </div>
          </>
        )}
      </div>
    </Link>
  );
};

export default BatteryLifeCard;
